import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../../../constants'

export const TitleRow = () => {
  return (
    <Root>
      <Type>
        <span>Type</span>
      </Type>
      <QTPO>
        <span>QT/PO</span>
      </QTPO>
      <ChangeReq>
        <span>Sub-Project Code</span>
      </ChangeReq>
      <Description>
        <span>Description</span>
      </Description>
      <DeliveryPlan>
        <span>Delivery Plan</span>
      </DeliveryPlan>
      <CreditTerm>
        <span>Credit Term</span>
      </CreditTerm>
      <ManDays>
        <span>Man-days</span>
      </ManDays>
      <Cost>
        <span>Costs</span>
      </Cost>
      <Price>
        <span>Prices</span>
      </Price>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 25px;
  display: grid;
  grid-gap: 0 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: 25px;
  background: #616161;
  padding: 0 24px;
`

const Type = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  span {
      font-family: ${FONTS.GOTHAM};
      font-size: ${FONTS.SMALL_SIZE};
      color: #FFFFFF;
  }
`

const QTPO = styled(Type)`
`

const ChangeReq = styled(Type)`
`

const Description = styled(Type)`
`

const DeliveryPlan = styled(Type)`
`

const CreditTerm = styled(Type)`
`

const ManDays = styled(Type)`
`

const Cost = styled(Type)`
  justify-content: flex-end;
`

const Price = styled(Type)`
  justify-content: flex-end;
`




// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-change-request/title-row.js